import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class UyrukListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "UyrukListe";
    super(baseUrl);
  }


  getUyrukListe( uyrukKodu?: number){
    return this.get("", { params: { uyrukKodu: uyrukKodu } })

  }

}


export default new UyrukListeAPI();
class UyrukListeListeRequest {
  public uyrukKodu?: number;

 
  constructor(uyrukKodu?: number) {
   
      this.uyrukKodu = uyrukKodu;

      
  }
}
export { UyrukListeListeRequest };